import type {
  FormattedPriceSettings,
  PriceSettingsType,
  PurchaseInfo,
} from '@setplex/tria-api'

import { MediaTypes } from '@setplex/tria-api'

export type Entity = {
  id?: number
  tvShowId?: number
  seasonId?: number
  free?: boolean
  purchaseInfo?: PurchaseInfo | null
  priceSettings?: FormattedPriceSettings[]
  seasonPriceSettings?: FormattedPriceSettings[]
  tvShowPriceSettings?: FormattedPriceSettings[]
  mediaType?: MediaTypesEx | null
  externalId?: string | null
  priceType?: PriceSettingsType
  rented?: boolean
}

export type TryIsPurchased = {
  entity?: Entity
  id?: number
  tvShowId?: number
  seasonId?: number
  link?: string
  mediaType?: MediaTypesEx | null
  shouldRefresh?: boolean
  externalId?: string
}

export type ISelectedPaymentContent = {
  mediaType?: MediaTypesEx | null
  externalId?: string | null
  priceType?: PriceSettingsType | null
} | null

export { MediaTypes }

export const MediaTypesExtended = {
  TV_CHANNEL_CATCHUP: 'TV_CHANNEL_CATCHUP',
  TV_CHANNEL_BUNDLE: 'TV_CHANNEL_BUNDLE',
  TV_CHANNEL_IN_BUNDLE: 'TV_CHANNEL_IN_BUNDLE',
  VOD_BUNDLE: 'VOD_BUNDLE',
  VOD_IN_BUNDLE: 'VOD_IN_BUNDLE',
  TV_SHOW_BUNDLE: 'TV_SHOW_BUNDLE',
  TV_SHOW_IN_BUNDLE: 'TV_SHOW_IN_BUNDLE',
  TV_SHOW_SEASON: 'TV_SHOW_SEASON',
  TV_SHOW_SEASON_IN_BUNDLE: 'TV_SHOW_SEASON_IN_BUNDLE',
  TV_SHOW_EPISODE: 'TV_SHOW_EPISODE',
  TV_SHOW_EPISODE_IN_BUNDLE: 'TV_SHOW_EPISODE_IN_BUNDLE',
  PARTNER_PRODUCT: 'PARTNER_PRODUCT',
} as const
export type MediaTypesExtended =
  (typeof MediaTypesExtended)[keyof typeof MediaTypesExtended]

export const MediaTypeInternal = {
  __REFRESH__: '__REFRESH__',
} as const
export type MediaTypeInternal =
  (typeof MediaTypeInternal)[keyof typeof MediaTypeInternal]

export type MediaTypesEx = MediaTypes | MediaTypesExtended | MediaTypeInternal

export type ExternalPaymentParams = {
  id: number
  mediaType?: MediaTypesEx | null
  shouldRefresh?: boolean

  // needed for tv shows episodes
  seasonId?: number
  tvShowId?: number

  // params for redirect to player, for different media types could be different
  params?: any
  externalId?: string | null
}

// Unique ID for pinlock popup when opening external payment
export const EXTERNAL_PAYMENT_PINLOCK_ID = -3
